import Typography from "@mui/material/Typography"

export default function HeaderPS() {
  return (
    <>
      <Typography
        align="center"
        variant="h2"
        sx={{ color: "primary.main", fontWeight: "medium" }}
      >
        Past Speakers
      </Typography>
      <Typography align="center" variant="body1" sx={{ mt: 1 }}>
        Here we present our honourable past speakers!
      </Typography>
    </>
  )
}
